// extracted by mini-css-extract-plugin
module.exports = {"container":"SortableMenu_container__2Aa_o","sorting":"SortableMenu_sorting__1t__Q","item":"SortableMenu_item__3syQ-","icon":"SortableMenu_icon__3y3oX"};